module.exports = __webpack_public_path__ + "img/share.ec2b3b19.svg";